import TestingType from './Testing.type';
import { Page_Size as PageSize } from '../../../../../Components/helper';

const initialState = {
  testingListData: [],
  testingSelectedIds: [],
  testingFilterValues: {
    selectedBrand: [],
    selectedProductSupplier: [],
    selectedSeason: [],
    selectedMonth: [],
    selectedYear: [],
    selectedCategory1: [],
    selectedCategory2: [],
    selectedCategory3: [],
    selectedCategory4: [],
    selectedTestingType: [],
    selectedBOM: [],
    selectedComponentSupplier: [],
    selectedColourRef: [],
    selectedStatus: [],
    selectedExpiry: [],
    selectedExclude: [],
    selectedLicensor: [],
    selectedLicense: [],
    selectedLikeness: [],
    searchText: '',
    pageIndex: 1,
    pageSize: PageSize,
    sortOrder: '',
    sortPropertyName: '',
    loading: false,
    selectedStartDate: '',
    selectedEndDate: '',
  },
  testingListTotalCount: 0,
  currentRequestId: null,
  brandList: [],
  seasonList: [],
  category1List: [],
  category2List: [],
  category3List: [],
  category3ListFrom4: [],
  category4List: [],
  userSuppliersList: [],
  suppliersList: [],
};

const testingTodoListReducer = (state = initialState, action) => {
  switch (action.type) {
    case TestingType.SET_TESTING_REQUESTS_TODOLIST: {
      if (
        action.payload.requestId &&
        state.currentRequestId &&
        Number(action.payload.requestId) < Number(state.currentRequestId)
      ) {
        return state;
      }
      return {
        ...state,
        testingListData: action.payload.isScrolled ? [...(state?.testingListData || []), ...(action?.payload?.data || [])] : action?.payload?.data || [],

        testingListTotalCount: action.payload.totalCount,
        currentRequestId: action.payload.requestId || state.currentRequestId,
      };
    }
    case TestingType.SET_SELECTED_IDS_ARRAY:
      return {
        ...state,
        testingSelectedIds: action.payload,
      };
    case TestingType.SET_FILTER_SORT_DATA:
      return {
        ...state,
        testingFilterValues: {
          ...state.testingFilterValues,
          ...action.payload,
        },
      };
    case TestingType.GET_MASTERS_BRANDS:
      return {
        ...state,
        brandList: action.payload,
      };
    case TestingType.GET_SEASONS:
      return {
        ...state,
        seasonList: action.payload,
      };
    case TestingType.GET_ALL_CATEGORY_1:
      return {
        ...state,
        category1List: action.payload,
      };
    case TestingType.GET_ALL_CATEGORY_2:
      return {
        ...state,
        category2List: action.payload,
      };
    case TestingType.GET_ALL_CATEGORY_3:
      return {
        ...state,
        category3List: action.payload,
      };
    case TestingType.GET_ALL_CATEGORY_4:
      return {
        ...state,
        category4List: action.payload,
      };
    case TestingType.GET_USER_SUPPLIERS:
      return {
        ...state,
        userSuppliersList: action.payload,
      };
    case TestingType.GET_SUPPLIER:
      return {
        ...state,
        suppliersList: action.payload,
      };
    default:
      return state;
  }
};

export default testingTodoListReducer;
